module.exports = __webpack_public_path__ + "img/article_ad_banner_03.f116bfa4.jpg";